'use strict'

import ApiClient from './ApiClient'

export default class ExpireSettingRepository {
  /**
   *  データの保存期間設定取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/expiresettings`)
  }

  /**
   * データの保存期間設定更新
   * @param params
   * @returns {*}
   */
  put (params) {
    return ApiClient().put(`/expiresettings`, params)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/ExpireSettingRepository.js